import script from "./ModalInformacaoesAdicionais.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalInformacaoesAdicionais.vue?vue&type=script&setup=true&lang=js"

import "./ModalInformacaoesAdicionais.vue?vue&type=style&index=0&id=67286426&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67286426"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QScrollArea});
